module.exports = __webpack_public_path__ + "img/k-yellow-woman-front.1f9e34bb.jpg";